import type { ConversationStatus } from '@lume/shared';

/** Spec fila §D6 (11/Ago): reabertura nunca é silenciosa — o cliente respondeu depois do
 *  encerramento e a conversa reabriu como estava. Sem este aviso, o retorno fica invisível. */
export function ReopenedBanner({
  reopenedAt,
  status,
}: {
  reopenedAt: string | null;
  status: ConversationStatus;
}): JSX.Element | null {
  if (reopenedAt === null || status !== 'awaiting-internal-action') return null;
  const min = Math.max(0, Math.round((Date.now() - new Date(reopenedAt).getTime()) / 60_000));
  // bound: 2× a janela de reabertura de 30min — banner é sobre o retorno IMEDIATO
  // pós-encerramento; sem writer que limpe reopenedAt, o tempo é o corte.
  if (min > 60) return null;
  return (
    <div className="banner banner--warning" role="status" data-testid="reopened-banner">
      <div className="banner__body">
        <strong>O cliente voltou depois do encerramento</strong> — a conversa reabriu há {min} min e
        está aguardando resposta.
      </div>
    </div>
  );
}
